import React, { useEffect, useState } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Drawer from '~/Common-Objects/UI/Drawer/Drawer.jsx'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import SnackBar from '~/Common-Objects/UI/Notifications/SnackBar/SnackBar'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import Toggle from '~/Common-Objects/UI/Forms/Toggle/Toggle'
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder'
import axios from '../../../../data/http/axios'
import i18n from '../../../../i18n'
import copy from 'copy-to-clipboard';

export default function Setup2fa({ accountUserData, reload = () => { } }) {
    const [account, setAccount] = useState(null)
    const [code, setCode] = useState('')
    const [enabling, setEnabling] = useState(false)
    const [disabling, setDisabling] = useState(false)
    const [image, setImage] = useState(null)
    const [error, setError] = useState('')
    const [tokens, setTokens] = useState(undefined)
    const [alert, setAlert] = useState({ open: false, message: '' })
    const [loading, setLoading] = useState(true)

    const enable = async () => {
        if (enabling) {
            setCode('')
            setEnabling(false)
        } else if (accountUserData.twoFAEnabled) {
            setDisabling(!disabling)
        } else {
            setLoading(true)
            const res = await axios.get('/accountUser/2fa')
            setLoading(false)
            setImage(res.data.image)
            setEnabling(true)
        }
    }

    const save = async () => {
        setLoading(true)
        const res = await axios.put('/accountUser/2fa', { twoFaCode: parseInt(code) })
        setLoading(false)
        if (!res.data.success) {
            return setError('Code Incorrect')
        } else {
            setTokens(res.data.tokens)
            setAlert({ open: true, message: enabling ? '2FA Enabled' : '2FA Disabled' })
            setCode('')
            setEnabling(false)
            setDisabling(false)
            reload()
        }
    }

    useEffect(() => {
        setLoading(true)
        axios.get('/accountMaster').then(res => {
            setAccount(res.data.AccountMaster)
            setLoading(false)
        })
    }, [])


    return (
        <Paper>
            <h4 className="mar-b25">{i18n.t('account:my.twoFa.header')}</h4>
            {(!account || loading) && <LoadingIcons />}
            {(account && !loading) && <>
                <div className="mar-b25">{i18n.t('account:my.twoFa.subHeader')}</div>
                {accountUserData.registered && <Toggle after={accountUserData.twoFAEnabled ? i18n.t('account:my.twoFa.enabled') : i18n.t('account:my.twoFa.disabled')} disabled={account?.options?.allUsersRequire2fa} name="twoFAEnabled" value={accountUserData.twoFAEnabled} onChange={enable} />}
                {!accountUserData.registered && <WarningHolder>Please confirm your email address before enabling</WarningHolder>}
                {account?.options?.allUsersRequire2fa && accountUserData.registered && accountUserData.twoFAEnabled && <WarningHolder className="mar-t10">You cannot disable 2fa due to an account policy</WarningHolder>}

                {enabling && <Row>
                    <Column xs={12} sm={6}>
                        {!image && <LoadingIcons iconType="2" />}
                        {!!image && <img src={image} style={{ width: "100%" }} />}
                    </Column>
                    <Column xs={12} sm={6}>
                        <h4 className="mar-b25">{i18n.t('account:my.twoFa.scanQrCode')}</h4>
                        <div className='mar-b25' dangerouslySetInnerHTML={{ __html: accountUserData.twoFAEnabled ? i18n.t('account:my.twoFa.instructions') : i18n.t('account:my.twoFa.firstLoad') }}></div>
                        <TextInput error={error} outerClassName="mar-b25" value={code} label="2FA Code" onChange={e => setCode(e.currentTarget.value)} onEnterPress={save} placeholder="2FA Code" />
                        <Button iconRight={<Icons icon="floppydisk" />} text="Save" onClick={save} className="button-primary" />
                    </Column>
                </Row>}

                {disabling && <Row className="mar-t20">
                    <Column xs={12} sm={12} className="mar-b25">
                        <div className='text-heavy'>To disable two factor authentication please enter your code below</div>
                    </Column>
                    <Column xs={12} sm={12}>
                        <TextInput error={error} outerClassName="mar-b25" value={code} label="2FA Code" onChange={e => setCode(e.currentTarget.value)} onEnterPress={save} placeholder="2FA Code" />
                    </Column>
                    <Column xs={12} sm={12}>
                        <Button iconRight={<Icons icon="floppydisk" />} text="Save" onClick={save} className="button-primary" />
                    </Column>
                </Row>}

                <SnackBar message={alert.message} open={alert.open} autoclose={true} dismiss={() => setAlert({ open: false })} />

                <Drawer standalone={true} isOpen={!!tokens} close={() => setTokens(undefined)} showClose={true}>
                    <Tokens tokens={tokens} copied={() => setAlert({ open: true, message: 'Tokens Copied to Clipboard' })} />
                </Drawer>
            </>}
        </Paper >
    )
}

function Tokens({ tokens = [], copied = () => { } }) {
    const copyToClipBoard = () => {
        copy(tokens)
        copied()
    }

    return (
        <>
            <h4 className='mar-b25'>Recovery Tokens</h4>
            <p>Take a note of these recovery tokens</p>
            <p>If you lose access to your authentication app you can use one of these tokens to login to your account</p>
            <p className='mar-b25'>You will only be able to use each token once</p>
            <code className='code code-copy' onClick={copyToClipBoard} style={{ flexFlow: "wrap" }}>
                <div className='code-copy-icon'><Icons icon="copyClipboard" /></div>
                {tokens.map(t => <div>{t}</div>)}
            </code>
        </>
    )
}